module.exports = "/_next/static/images/admissionInstructionDesktopImage-a0bff4505bd0262a9c6adafdb7ac5d3b.png";